import React, { useState } from "react";
import { Alert, Snackbar } from "@mui/material";

export const ErrorAlert = ({ error }: { error: string }): JSX.Element => {
	const [alert, setAlert] = useState(true);
	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
			onClose={() => setAlert(false)}
			open={alert}
			autoHideDuration={3000}
		>
			<Alert elevation={6} variant="filled" severity="error">
				Sorry, Email is Not Sent Because of {error}
			</Alert>
		</Snackbar>
	);
};

export const SuccessAlert = ({ email }: { email: string }): JSX.Element => {
	const [alert, setAlert] = useState(true);
	return (
		<Snackbar
			anchorOrigin={{ vertical: "top", horizontal: "center" }}
			onClose={() => setAlert(false)}
			open={alert}
			autoHideDuration={3000}
		>
			<Alert elevation={3} variant="filled" severity="success">
				<p>
					<strong>Success 🎉</strong>
				</p>
				<p>The Academic Result is being processed.</p>
				<p>The result will be emailed to your email address {email}.</p>
			</Alert>
		</Snackbar>
	);
};
